function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import { Form, Button } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import SemanticReduxFormField from './SemanticReduxFormField';

var ForgotPasswordForm = function (_React$Component) {
  _inherits(ForgotPasswordForm, _React$Component);

  function ForgotPasswordForm(props) {
    _classCallCheck(this, ForgotPasswordForm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleInputChange = function (event) {
      _this.setState({
        email: event.target.value
      });
    };

    _this.state = {
      email: ''
    };
    return _this;
  }
  /* TODO: Error handling, once the API has been implemented */


  ForgotPasswordForm.prototype.render = function render() {
    var _props = this.props,
        handleSubmit = _props.handleSubmit,
        isFetching = _props.isFetching;
    var email = this.state.email;
    return React.createElement(Form, {
      onSubmit: function onSubmit() {
        return handleSubmit(email);
      },
      className: 'login-form__form'
    }, React.createElement(Form.Input, {
      label: 'Email',
      name: 'email',
      type: 'text',
      onChange: this.handleInputChange,
      disabled: isFetching
    }), React.createElement('div', {
      className: 'login-form__buttons'
    }, React.createElement(Button, {
      type: 'submit',
      loading: isFetching
    }, 'Reset Password'), React.createElement(NavLink, {
      to: '/login',
      className: 'login-form__forgot-button'
    }, 'Log In')));
  };

  return ForgotPasswordForm;
}(React.Component);

export default ForgotPasswordForm;